import React, { useEffect, useState } from "react";
import { Typography, IconButton, Button } from "@material-tailwind/react";
import { Popover } from "react-tiny-popover";
import {
    ArrowDownTrayIcon,
    DocumentIcon,
    EllipsisVerticalIcon,
    EyeIcon,
    FunnelIcon,
} from "@heroicons/react/24/solid";
import { fetchOrderPayments } from "@/store/slices/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import DownloadFile from "@/components/DownloadFile";
import Swal from "sweetalert2";
import { approveRejectPaymentReceipt } from "@/store/slices/rfqSlice";
import Toaster from "@/components/Toaster";
import DocumentViewModal from "@/components/DocumentViewModal";
import { useTranslation } from "react-i18next";

function formatDate(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return (
        d.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        }) +
        " | " +
        d.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        })
    );
}

// API expects order_id: admin/payment-details/${order_id}
export function OrderPayments({ orderId, rfq_id, order_details }) {
    const { t } = useTranslation('order');
    const { t: ct } = useTranslation('common');

    const dispatch = useDispatch();
    const [filter, setFilter] = useState('');
    const [checkedIds, setCheckedIds] = useState([]);
    const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);
    const [actionPopoverOpen, setActionPopoverOpen] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);


    const { user } = useSelector((state) => state.user);

    const { order_payments, loading } = useSelector((state) => state.order);

    useEffect(() => {
        if (rfq_id) dispatch(fetchOrderPayments({ order_id: rfq_id, filter: filter }));
    }, [rfq_id, dispatch, filter]);

    const toggleCheck = (id) => {
        setCheckedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    // const onApproveReject = (type, id) => {
    //     const msg = type === "approved" ? "approve" : "reject";
    //     if (type === 'approved') {
    //         Swal.fire({
    //             title: "Approve Payment Receipt",
    //             icon: "question",
    //             html: `
    //                 <p class="text-sm text-gray-600 mb-2">
    //                 Please enter the approved receipt amount before confirming.
    //                 </p>
    //             `,
    //             input: "number",
    //             inputLabel: "Receipt Amount",
    //             inputPlaceholder: "Enter amount",
    //             inputAttributes: {
    //                 min: 1,
    //                 step: "0.01"
    //             },
    //             showCancelButton: true,
    //             confirmButtonText: "Approve & Save",
    //             cancelButtonText: "Cancel",
    //             confirmButtonColor: "#16a34a",
    //             cancelButtonColor: "#d33",
    //             focusConfirm: false,

    //             preConfirm: (value) => {
    //                 if (!value) {
    //                     Swal.showValidationMessage("Receipt amount is required");
    //                     return false;
    //                 }
    //                 if (Number(value) <= 0) {
    //                     Swal.showValidationMessage("Amount must be greater than 0");
    //                     return false;
    //                 }
    //                 return Number(value);
    //             }
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 const receiptPrice = result.value;
    //                 dispatch(approveRejectPaymentReceipt({ status: type, id: id, amount_paid: receiptPrice }))
    //                     .unwrap()
    //                     .then(() => {
    //                         Toaster.success(`Receipt ${type} successfully!`);
    //                         dispatch(fetchOrderPayments({ order_id: rfq_id, filter: filter }))
    //                     })
    //                     .catch(() => Toaster.error("Failed to perform action."));

    //             }
    //         });

    //     } else {
    //         Swal.fire({
    //             title: "Are you sure?",
    //             text: `Do you really want to ${msg} this payment receipt?`,
    //             icon: "warning",
    //             showCancelButton: true,
    //             confirmButtonColor: "#16a34a",
    //             cancelButtonColor: "#dc2626",
    //             confirmButtonText: "Yes",
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 dispatch(approveRejectPaymentReceipt({ status: type, id }))
    //                     .unwrap()
    //                     .then(() => {
    //                         Toaster.success(`Receipt ${type} successfully!`);
    //                         dispatch(fetchOrderPayments({ order_id: rfq_id, filter: filter }))
    //                     })
    //                     .catch(() => Toaster.error("Failed to perform action."));
    //             }
    //         });
    //     }
    // };

    const onApproveReject = (type, id) => {
        const msg = type === "approved" ? "approve" : "reject";
        
        if (type === 'approved') {
            Swal.fire({
                title: t('approve_payment_receipt_title'),
                icon: "question",
                html: `
                    <div class="text-left mt-4">
                        <div class="mb-4">
                            <label for="swal-amount" class="block text-sm font-medium text-gray-700 mb-1">
                                ${t('receipt_amount_label')}
                            </label>
                            <input 
                                type="number" 
                                id="swal-amount" 
                                class="swal2-input !m-0 !w-full !border !border-gray-300 focus:!border-green-500 !rounded-md !shadow-sm" 
                                placeholder="0.00" 
                                step="0.01"
                            >
                        </div>
                        
                        <div class="mb-2">
                            <label for="swal-payment-type" class="block text-sm font-medium text-gray-700 mb-1">
                                ${t('payment_type_label')}
                            </label>
                            <select 
                                id="swal-payment-type" 
                                class="swal2-select !m-0 !w-full !flex !border !border-gray-300 focus:!border-green-500 !rounded-md !shadow-sm !h-[42px] !px-2"
                            >
                                <option value="" disabled selected>${t('select_payment_type')}</option>
                                <option value="1">${t('payment_type_cash')}</option>
                                <option value="2">${t('payment_type_net_banking')}</option>
                                <option value="3">${t('payment_type_upi')}</option>
                                <option value="4">${t('payment_type_rtgs')}</option>
                                <option value="5">${t('payment_type_cheque')}</option>
                                <option value="6">${t('payment_type_others')}</option>
                            </select>
                        </div>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: t('approve_and_save_button'),
                cancelButtonText: ct('cancel'),
                confirmButtonColor: "#16a34a",
                cancelButtonColor: "#d33",
                focusConfirm: false,
                preConfirm: () => {
                    const amount = document.getElementById('swal-amount').value;
                    const paymentType = document.getElementById('swal-payment-type').value;

                    const numericAmount = Number(amount);
                    const pendingAmount = Number(order_payments?.summary?.amount_pending ?? 0);

                    if (!amount) { // This is a validation message, not a label.
                        Swal.showValidationMessage(t('receipt_amount_required'));
                        return false;
                    }

                    if (numericAmount <= 0) { // This is a validation message, not a label.
                        Swal.showValidationMessage(t('amount_greater_than_zero'));
                        return false;
                    }

                    if (pendingAmount && (numericAmount > pendingAmount)) { // This is a validation message, not a label.
                        Swal.showValidationMessage(
                            t('amount_cannot_be_greater_than_pending', { pendingAmount })
                        );
                        return false;
                    }

                    if (!paymentType) { // This is a validation message, not a label.
                        Swal.showValidationMessage(t('select_payment_type_validation'));
                        return false;
                    }

                    return { 
                        amount_paid: numericAmount, 
                        payment_mode: paymentType 
                    };
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const { amount_paid, payment_mode } = result.value;
                    
                    dispatch(approveRejectPaymentReceipt({ 
                        status: type, 
                        id: id, 
                        amount_paid, 
                        payment_mode 
                    }))
                    .unwrap()
                    .then(() => { // This is a toaster message, not a label.
                        Toaster.success(t('receipt_approved_success'));
                        dispatch(fetchOrderPayments({ order_id: rfq_id, filter: filter }));
                    }) // This is a toaster message, not a label.
                    .catch(() => Toaster.error("Failed to perform action."));
                }
            });

        } else {
            // ... Rejection logic stays the same
            // Swal.fire({
            //     title: "Are you sure?",
            //     text: `Do you really want to reject this payment receipt?`,
            //     icon: "warning",
            //     showCancelButton: true,
            //     confirmButtonColor: "#16a34a",
            //     cancelButtonColor: "#dc2626",
            //     confirmButtonText: "Yes",
            // }).then((result) => {
            //     if (result.isConfirmed) {
            //         dispatch(approveRejectPaymentReceipt({ status: type, id }))
            //             .unwrap()
            //             .then(() => {
            //                 Toaster.success(`Receipt rejected successfully!`);
            //                 dispatch(fetchOrderPayments({ order_id: rfq_id, filter: filter }));
            //             })
            //             .catch(() => Toaster.error("Failed to perform action."));
            //     }
            // });
            Swal.fire({
                title: t('reject_payment_receipt_title'),
                text: t('reject_payment_receipt_text'),
                icon: "warning",
                input: "textarea", // Using textarea for longer reasons
                inputPlaceholder: t('enter_rejection_reason_placeholder'),
                inputAttributes: {
                    autocapitalize: "off"
                },
                showCancelButton: true,
                confirmButtonColor: "#16a34a",
                cancelButtonColor: "#dc2626",
                confirmButtonText: t('submit_rejection_button'),
                // --- Validation Logic ---
                inputValidator: (value) => {
                    if (!value) { // This is a validation message, not a label.
                        return t('rejection_reason_required');
                    }
                    if (value.length < 10) { // This is a validation message, not a label.
                        return t('rejection_reason_min_length');
                    }
                    if (value.length > 100) { // This is a validation message, not a label.
                        return t('rejection_reason_max_length');
                    }
                }
            }).then((result) => { // This is a toaster message, not a label.
                if (result.isConfirmed) {
                    // result.value contains the text entered by the user
                    const reason = result.value;

                    dispatch(approveRejectPaymentReceipt({ 
                        status: type, 
                        id: id, 
                        reason: reason // Pass the reason to your API
                    }))
                    .unwrap()
                    .then(() => { // This is a toaster message, not a label.
                        Toaster.success(t('receipt_rejected_success'));
                        dispatch(fetchOrderPayments({ order_id: rfq_id, filter: filter }));
                    }) // This is a toaster message, not a label.
                    .catch(() => Toaster.error(t('rejection_failed')));
                }
            });
        }
    };


    const toggleActionPopover = (id) => {
        setActionPopoverOpen((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <div className="w-full">
            <div className="mb-7 grid gap-y-3 gap-x-3 md:grid-cols-2 xl:grid-cols-4">
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {(order_details?.payment_summary?.grand_total ?? 0).toLocaleString("en-IN")}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2">
                        {t('total_amount_label')} ({order_details?.payment_summary?.currency_code})
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {(order_details?.payment_summary?.paid_amount ?? 0).toLocaleString("en-IN")}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2">
                        {t('amount_paid_label')} ({order_details?.payment_summary?.currency_code})
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {(order_details?.payment_summary?.due_amount ?? 0).toLocaleString("en-IN")}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2">
                        {t('amount_pending_label')} ({order_details?.payment_summary?.currency_code})
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {(order_payments?.summary?.refund_request ?? 0).toLocaleString("en-IN")}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2">
                        {t('refund_request_label')} ({order_details?.payment_summary?.currency_code})
                    </Typography>
                </div>
            </div>
            {/* Controls Bar - Order Items (adapted for Payments) */}
            <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-4">
                <div className="flex items-center gap-4">
                    <Typography variant="h6" color="blue-gray" className="font-bold">
                        {t('invoices_title', { count: order_payments?.payments?.length ?? 0 })}
                    </Typography>
                </div>

                {/* <div className="flex items-center gap-3 flex-wrap">
                    <Popover
                        isOpen={isFilterPopoverOpen}
                        positions={["bottom"]}
                        onClickOutside={() => setIsFilterPopoverOpen(false)}
                        content={
                            <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2" onClick={() => { setFilter(''); setIsFilterPopoverOpen(false); }}>All</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2" onClick={() => { setFilter('approved'); setIsFilterPopoverOpen(false); }}>Approved</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2" onClick={() => { setFilter('rejected'); setIsFilterPopoverOpen(false); }} >Rejected</button>
                            </div>
                        }
                    >
                        <Button
                            onClick={() => setIsFilterPopoverOpen(!isFilterPopoverOpen)}
                            variant="outlined"
                            className="flex items-center gap-2 border-gray-300 capitalize"
                        >
                            <FunnelIcon className="h-4 w-4" />
                            Filter {filter ? `(${filter})` : ''}
                        </Button>
                    </Popover>
                </div> */}
            </div>

            <div className="w-full overflow-x-auto rounded-lg">
                <table className="w-full min-w-[800px]">
                    {/* <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead> */}
                    <tbody>
                        {!(order_payments?.payments?.length) ? (
                            <tr>
                                <td colSpan="5" className="py-10 text-center text-gray-500 italic">
                                    {t('no_invoices_message')}
                                </td>
                            </tr>
                        ) : (
                            order_payments.payments.map((item, index) => (<>
                                <tr key={item.id ?? index} className="border-b border-gray-300 hover:bg-gray-50 transition">
                                    {/* Invoice Name */}
                                    <td className="py-4 px-4 first:pl-0 last:pr-0 align-top">
                                        <span className="text-sm font-medium text-gray-900">{t('invoice_number_label', { number: index + 1 })}</span>
                                    </td>

                                      {/* Amount */}
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <span className="text-sm font-bold text-gray-900">
                                            {item?.currency_code || ''} {item.amount_paid && Number(item.amount_paid).toLocaleString() || "N/A"}
                                        </span>
                                    </td>

                                    {/* Status Badge */}
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize
                                            ${item.status === "pending" ? "bg-yellow-100 text-yellow-800" : ""}
                                            ${item.status === "approved" ? "bg-green-100 text-green-800" : ""}
                                            ${item.status === "rejected" ? "bg-red-100 text-red-800" : ""}
                                        `}>
                                            {t(`status.${item?.status}`)}
                                        </span>
                                    </td>

                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <span className="text-sm font-medium text-gray-900">{item?.payment_mode}</span>
                                    </td>

                                    {/* Date */}
                                    <td className="px-4 py-4 whitespace-nowrap">
                                        <span className="text-sm text-gray-500">{formatDate(item.created_at)}</span>
                                    </td>

                                    {/* Actions */}
                                    <td className="px-4 py-4 whitespace-nowrap text-right text-sm font-medium">
                                        <div className="flex items-center justify-end gap-2">
                                            {/* {item?.payment_invoice && (
                                                <EyeIcon title="Invoice" className="h-4 w-4 text-gray-500 cursor-pointer" onClick={() => setIsModalOpen(item?.payment_invoice)}/>
                                            )} */}
                                            {item?.payment_invoice && ( // This is a component prop, not a label.
                                                <DownloadFile fileUrl={item.payment_invoice} label={t('invoice_label')}/>
                                            )}
                                            {item?.payment_receipt && ( // This is a component prop, not a label.
                                                <EyeIcon title="Customer Payment Receipt" className="h-4 w-4 text-gray-500 cursor-pointer" onClick={() => setIsModalOpen(item?.payment_receipt[0])}/>
                                            )}
                                            
                                            {item.status === 'pending' && (user?.roles.some(r => ['Finance', 'Administrator'].includes(r))) && (
                                                <Popover
                                                    isOpen={actionPopoverOpen[item.id]}
                                                    positions={["bottom", "left"]}
                                                    padding={4}
                                                    onClickOutside={() => toggleActionPopover(item.id)}
                                                    content={
                                                        <div className="bg-white shadow-xl rounded-md w-32 flex flex-col z-50 border border-gray-200 py-1 overflow-hidden">
                                                            <button 
                                                                className="text-left text-sm text-gray-700 hover:bg-gray-50 px-4 py-2 transition-colors" 
                                                                onClick={() => onApproveReject('approved', item.id)}
                                                            >
                                                                {t('approve_button')}
                                                            </button>
                                                            <button 
                                                                className="text-left text-sm text-red-600 hover:bg-red-50 px-4 py-2 transition-colors" 
                                                                onClick={() => onApproveReject('rejected', item.id)}
                                                            >
                                                                {t('reject_button')}
                                                            </button>
                                                        </div>
                                                    }
                                                >
                                                    <IconButton
                                                        variant="text"
                                                        size="sm"
                                                        className="rounded-full hover:bg-gray-100"
                                                        onClick={() => toggleActionPopover(item.id)}
                                                    >
                                                        <EllipsisVerticalIcon className="h-5 w-5 text-gray-500" />
                                                    </IconButton>
                                                </Popover>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                {item?.rejection_reason &&
                                 <tr key={item.id+"rejection_reason"} className="border-b border-gray-300 hover:bg-gray-50 transition">
                                    {/* Invoice Name */}
                                    <td className="py-4 px-4 first:pl-0 last:pr-0 align-top" colSpan={5}>
                                        <span className="text-sm font-medium text-gray-900 text-red-800">{t('rejection_reason_label')}: {item?.rejection_reason}</span>
                                    </td>
                                </tr>
                                }</>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {isModalOpen && <DocumentViewModal documentUrl={isModalOpen} setIsDocumentViewModalOpen={setIsModalOpen} />}
            
        </div>
    );
}

export default OrderPayments;
